import axios from 'axios';
import { getRequestConfig } from 'src/api/communicate/tools/payload';
import CommunicateInterceptor from 'src/api/communicate/tools/interceptor';
import errorEnhancer from './errorEnhancer';
function isGetRequest({ method }) {
    return method === 'get' || method === 'GET';
}
export async function communicateFunc(requestData) {
    if (process.env.NODE_ENV === 'test') {
        const err = 'NO API REQUESTS WHILE TESTING';
        return Promise.reject(err);
    }
    const requestConfig = await getRequestConfig(requestData);
    if (isGetRequest(requestConfig)) {
        return CommunicateInterceptor.handleGetRequest(requestConfig);
    }
    else {
        return axios(requestConfig);
    }
}
export default errorEnhancer(communicateFunc);
